<template>
  <div class="append-box" @touchmove="gtouchmove">
    <v-mask style="background:none" :zIndex="10000"></v-mask>
    <div
      v-bind:class="{'animated baisonToastFadeInDown horizontal-center toast-box':true,'baisonToastFadeInUp':fadeOut}"
    >{{text}}</div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
export default {
  name: "toast",
  components: {
    "v-mask": vmask,
  },
  data() {
    return {
      text: "Toast",
      time: 300,
      fadeOut: false,
      timer1: null,
      timer2: null,
    };
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      if (this.timer1 != null) {
        window.clearTimeout(this.timer1);
      }
      if (this.timer2 != null) {
        window.clearTimeout(this.timer2);
      }
      this.timer1 = setTimeout(() => {
        this.fadeOut = true;
        if (this.timer1 != null) {
          clearTimeout(this.timer1);
        }
        this.timer2 = setTimeout(() => {
          if (this.timer2 != null) {
            clearTimeout(this.timer2);
          }
          this.fadeOut = false;
          this.$el.parentNode.removeChild(this.$el);
          this.$destroy(true);
          window.__ToastInstance = null;
        }, 900);
      }, this.time);
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    update(options) {
      for (let o in options) {
        this[o] = options[o];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 188889;
  .toast-box {
    color: #fff;
    font-size: 0.13rem;
    line-height: 0.13rem;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 0.1rem 0.2rem;
    border-radius: 0.025rem;
    bottom: 10%;
  }
}
</style>